import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const CERTIFICATES_ROUTES: Routes = [
  {
    path: "certificates",
    loadComponent: () => import("./certificates.component").then(m => m.CertificatesComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.certificates" },
    children: [
      {
        path: "",
        loadComponent: () => import("./certificates-info/certificates-info.component").then(m => m.CertificatesInfoComponent),
        data: { title: "pageTitles.certificates" },
      },
      {
        path: "review",
        loadComponent: () => import("./certificates-review/certificates-review.component").then(m => m.CertificatesReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.certificatesReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.certificatesMessages" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
